import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { useFormik } from "formik";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import SearchBoxModal from "../component/SearchBoxModal";
import AlertErrorForm from "../component/AlertErrorForm";
import * as Yup from "yup";
import Moment from "react-moment";

export default function XuatBangChamCong(props) {
    const { user } = useSelector((state) => state.auth);
    const { saveReloadBCC } = useSelector((state) => state.save);
    const [month, setMonth] = useState([]);
    const [year, setYear] = useState([]);
    const [listCompany, setListCompany] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingQueue, setLoadingQueue] = useState(false);
    const [listData, setListData] = useState([]);
    const [realoader, setReloader] = useState([]);

    const formik = useFormik({
        initialValues: { month: new Date().getMonth() + 1, year: new Date().getFullYear() },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            month: Yup.string().trim().nullable().required('Vui lòng chọn tháng'),
            year: Yup.string().trim().nullable().required('Vui lòng chọn năm')
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            loadBcc(values.month, values.year, values.company_id)
        },
    });

    const loadBcc = (month, year, company_id = null) => {
        setLoadingQueue(true)
        Axios.get(`${URL_LIST_ALL}export_bcc?month=${month}&year=${year}` + (company_id ? '&company_id=' + company_id : ''), user.config)
            .then(res => {
                setLoading(false)
                setLoadingQueue(false)
                if (res.data.status === "success") {
                    setListData(res.data.data)
                    setReloader([])
                } else {
                    confirmAlert({ title: 'Thông báo', message: res.data.message, buttons: [{ label: 'OK' }] });
                }
            }).catch(err => {
                setLoading(false)
                confirmAlert({ title: 'Lỗi', message: err.message, buttons: [{ label: 'OK' }] });
                console.log(err);
            });
    }
    useEffect(() => {
        if (saveReloadBCC && formik && formik.values && !loadingQueue) {
            loadBcc(formik.values['month'], formik.values['year'], formik.values['company_id'])
        }
    }, [saveReloadBCC]);

    useEffect(() => {
        setMonth(Array.from({ length: 12 }, (_, i) => i + 1));
        setYear(Array.from({ length: new Date().getFullYear() - 2020 }, (_, i) => 2021 + i));
    }, []);

    useEffect(() => {
        Axios.get(`${URL_LIST_ALL}company?limit=1000`, user.config)
            .then(res => {
                if (res.data.status === "success") {
                    setListCompany(res.data.data.map(item => ({ id: item.id, title: item.title })));
                } else {
                    confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                }
            })
            .catch(err => {
                confirmAlert({ title: 'Lỗi', message: err.message, buttons: [{ label: 'OK' }] });
                console.log(err);
            });
    }, []);

    // Xuất file vi phạm / trừ thưởng (tô vàng dòng vi phạm) — gọi endpoint export_vipham_chamcong
    const exportVipham = () => {
        const month = formik.values['month'];
        const year = formik.values['year'];
        if (!month || !year) {
            confirmAlert({ title: 'Thông báo', message: 'Vui lòng chọn tháng và năm', buttons: [{ label: 'OK' }] });
            return;
        }
        const company_id = formik.values['company_id'];
        setLoading(true);
        Axios.get(`${URL_LIST_ALL}export_vipham_chamcong?time=${year}-${month}` + (company_id ? '&company_id=' + company_id : ''), user.config)
            .then(res => {
                setLoading(false);
                if (res.data.status === 'success' && res.data.data) {
                    fetch(res.data.data)
                        .then((r) => r.blob())
                        .then((blob) => {
                            let url = window.URL.createObjectURL(blob);
                            url = url.replace(/^http:\/\//i, 'https://');
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = res.data.data.split('/').pop();
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            window.URL.revokeObjectURL(url);
                        })
                        .catch(() => alert('Không thể tải file vi phạm. Vui lòng thử lại.'));
                } else {
                    confirmAlert({ title: 'Thông báo', message: res.data.message || 'Không có dữ liệu vi phạm', buttons: [{ label: 'OK' }] });
                }
            })
            .catch(err => {
                setLoading(false);
                confirmAlert({ title: 'Lỗi', message: err.message, buttons: [{ label: 'OK' }] });
            });
    }

    const CreateBCC = (id) => {
        Axios.put(`${URL_LIST_ALL}bcc_queue/${id}`, { status: 0,user_id:user.data.id }, user.config)
            .then(res => {
                if (res.data.status === "success") {
                    setReloader(prev => [...prev, id])
                } else {
                    confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                }
            })
            .catch(err => {
                confirmAlert({ title: 'Lỗi', message: err.message, buttons: [{ label: 'OK' }] });
                console.log(err);
            });
    }

    return (
        <AkkhorLayout idrole="list-users">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/list-users_onday">Danh sách chấm công</Link></li>
                    <li>Xuất bảng chấm công</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Xuất bảng Chấm công</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 mg-t-8">
                                <div className="col-12 col-sm-4 form-group">
                                    <label>Chọn tháng</label>
                                    <select className="form-select height32" {...formik.getFieldProps("month")}>
                                        <option value="0">Chọn tháng</option>
                                        {month.map((item, i) => (
                                            <option key={i} value={item < 10 ? '0' + item : item}>Tháng {item}</option>
                                        ))}
                                    </select>
                                    <AlertErrorForm formik={formik} name="month" />
                                </div>
                                <div className="col-12 col-sm-4 form-group">
                                    <label>Chọn năm</label>
                                    <select className="form-select height32" {...formik.getFieldProps("year")}>
                                        <option value="0">Chọn năm</option>
                                        {year.map((item, i) => (
                                            <option key={i} value={item}>{item}</option>
                                        ))}
                                    </select>
                                    <AlertErrorForm formik={formik} name="year" />
                                </div>
                                <div className="col-12 col-sm-4 form-group">
                                    <label>Xuất theo Công ty</label>
                                    <SearchBoxModal
                                        apiname="company"
                                        placeholder="Chọn công ty"
                                        all={true}
                                        colvalue="id"
                                        colname="title"
                                        formik={formik}
                                        name="company_id"
                                        onChange={async (e) => await formik.setFieldValue('company_id', e)}
                                    />
                                    <AlertErrorForm formik={formik} name="company_id" />
                                </div>

                                <div className="alert alert-primary" role="alert">
                                    <button type="submit" disabled={formik.isSubmitting && (listCompany.length > 0)} className="btn btn-warning mr-2">
                                        {formik.isSubmitting || loading ? <Spinner /> : <>Xuất File</>}
                                    </button>
                                    <button type="button" disabled={loading} onClick={exportVipham} className="btn  btn-success mr-2">
                                        {loading ? <Spinner /> : <>Xuất file Vi phạm / Trừ thưởng</>}
                                    </button>
                                </div>
                            </div>
                            {(listData && listData.length > 0) && <>
                                <table className="table table-striped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Đơn vị</th>
                                            <th>Người tạo</th>
                                            <th>Ngày tạo</th>
                                            <th>File</th>
                                            <th>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listData.map((item, k) => {
                                            return (<tr key={k}>
                                                <td>{item.company_name ? item.company_name : "Tất cả"}</td>
                                                <td>{item.author_name}</td>
                                                <td>{item.datecreate ? <Moment format="HH:MM DD/MM/YYYY">{new Date(item.datecreate * 1000)}</Moment> : null}</td>
                                                <td>
                                                    {(item.status == 1 && (!realoader.includes(item.id))) ?
                                                        <button
                                                            className="btn btn-primary"
                                                            type="button"
                                                            onClick={() => {
                                                                fetch(item.file_url)
                                                                    .then((res) => res.blob())
                                                                    .then((blob) => {
                                                                        let url = window.URL.createObjectURL(blob);
                                                                        url = url.replace(/^http:\/\//i, 'https://');
                                                                        const a = document.createElement('a');
                                                                        a.href = url;
                                                                        a.download = item.file_name;
                                                                        document.body.appendChild(a);
                                                                        a.click();
                                                                        a.remove();
                                                                        window.URL.revokeObjectURL(url);
                                                                    })
                                                                    .catch((e) => {
                                                                        console.log(e);
                                                                        alert("Không thể tải file. Vui lòng thử lại.");
                                                                    });
                                                            }}
                                                        >
                                                            Tải file {item.file_name}
                                                        </button>
                                                        :
                                                        <div className="d-flex">
                                                            <strong className="text-danger">Đang tổng hợp...</strong>
                                                            <div className="loader loader-sm"></div>
                                                        </div>
                                                    }
                                                </td>
                                                <td>
                                                    {((item.status == 1 && (!realoader.includes(item.id)))) && <button className="btn btn-sm btn-warning" type="button" onClick={() => CreateBCC(item.id)}>Tạo lại</button>}
                                                </td>
                                            </tr>)
                                        })}
                                    </tbody>
                                </table>

                            </>}
                            {/* {linkDown.length > 0 && (
                                <div className="row">
                                    {linkDown.map((item, i) => (
                                        <div className="col text-center mb-2" key={i}>
                                            <a className="btn btn-danger" href={item.data}>Tải về: {item.title}</a>
                                        </div>
                                    ))}
                                </div>
                            )} */}

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
